import type { Language } from '../../types/document'
import type { NumberSpeller } from './types'
import { en } from './en'
import { hi } from './hi'
import { bn } from './bn'
import { mr } from './mr'
import { ta } from './ta'
import { te } from './te'
import { gu } from './gu'
import { kn } from './kn'
import { ml } from './ml'
import { pa } from './pa'
import { or } from './or'
import { asm } from './as'

export type { NumberSpeller } from './types'

const SPELLERS: Record<Language, NumberSpeller> = { hi, en, bn, mr, ta, te, gu, kn, ml, pa, or, as: asm }

export function spellerFor(language: Language): NumberSpeller {
  return SPELLERS[language] ?? en
}
